import React from 'react';
import { IconType } from '../../types';

interface Props {
    iconUrl: string,
    iconType: IconType,
    multipart?: boolean,
}

export default ({ iconUrl, iconType, multipart }: Props) => {
    if (iconType === 'icon') {
        return (
            <img src={iconUrl} alt="" className="img-fluid" />
        );
    }

    if (iconType === 'previewImage') {
        const classes = multipart
            ? 'icon-mental-video icon-mental-video-multi' : 'icon-mental-video';
        return (
            <div className="icon-mental-container">
                <img src={iconUrl} alt="" className={classes} />
                <img src="/images/icon-video-play.svg" alt="" className="icon-mental-video-play" />
            </div>
        );
    }

    return null;
};
